<mat-paginator
  [length]="total"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="showFirstLastButtons"
  [hidePageSize]="hidePageSize"
></mat-paginator>
